// Simple function to prevent Gatsby from trying to use the window object during SSR.
export const isServerSideRendering = (): boolean =>
  typeof window === "undefined";
